import React, { useState } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const API_BASE = process.env.REACT_APP_API_URL || "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(data.message);
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError("Failed to connect to the server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <SiteHeader />
      <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Reset Password</h1>
        <p style={styles.subtitle}>Enter your email to receive a reset link</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="email"
            placeholder="Email"
            style={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          
          {message && <p style={styles.success}>{message}</p>}
          {error && <p style={styles.error}>{error}</p>}

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <div style={styles.footer}>
          <Link to="/login" style={styles.link}>Back to Login</Link>
        </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}

const styles = {
  // Same shell as every other public page: sticky SiteHeader, content that
  // grows, SiteFooter pinned to the bottom.
  page: {
    minHeight: "100vh", display: "flex", flexDirection: "column",
    background: "#F4F4F0",
  },
  container: {
    display: "flex", alignItems: "center", justifyContent: "center",
    flex: 1, padding: "32px 20px", fontFamily: "'JetBrains Mono', monospace"
  },
  card: {
    background: "white", padding: "40px", borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.05)", width: "100%", maxWidth: "400px",
    textAlign: "center"
  },
  title: { fontSize: "24px", fontWeight: "700", marginBottom: "8px" },
  subtitle: { fontSize: "14px", color: "#666", marginBottom: "32px" },
  form: { display: "flex", flexDirection: "column", gap: "16px" },
  input: {
    padding: "12px", borderRadius: "8px", border: "1px solid #ddd",
    fontSize: "14px", outline: "none", fontFamily: "inherit"
  },
  button: {
    padding: "12px", borderRadius: "8px", border: "none",
    background: "#7c6af7", color: "white", fontWeight: "700",
    cursor: "pointer", fontSize: "14px", marginTop: "8px"
  },
  error: { color: "#ff4d4d", fontSize: "12px", margin: "0" },
  success: { color: "#28a745", fontSize: "12px", margin: "0" },
  footer: { marginTop: "24px" },
  link: { color: "#7c6af7", fontSize: "12px", textDecoration: "none" }
};
